import { render, staticRenderFns } from "./ArticlePageNumber.vue?vue&type=template&id=2f3be586&"
import script from "./ArticlePageNumber.vue?vue&type=script&lang=ts&"
export * from "./ArticlePageNumber.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports